<template>
  <div>
    <el-row id="sign-in-manage-edit">
      <el-col>
        <el-button type="text" icon="el-icon-arrow-left" @click="back">返回</el-button>
        <el-row v-loading="loading" class="sign-content">
          <el-row>
            <el-row>
              <el-col :span="8" :xs="12">
                <span class="cs-title">{{ param.courseName }} 签到记录</span>
              </el-col>
              <el-col :span="12" :xs="12">
                <el-button size="medium" v-if="!isView" :loading="isSaveAttendance" type="primary" @click="saveAttendance">保存出勤率</el-button>
                <el-button size="medium" v-if="!isView" type="primary" @click="calculateAbsence">计算缺勤率</el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :xs="12" v-if='param.usage !== "vocationalTraining"'>速成老师: {{ param.teacherName }}</el-col>
              <el-col :span="8" :xs="12" v-if='param.usage == "vocationalTraining"'>老师: {{ param.teacherName }}</el-col>
              <el-col :span="8" :xs="12">报名人数: {{ !!tableData && !!tableData.SignInMgtStudentList ?
                tableData.SignInMgtStudentList.length - 1 : "" }}</el-col>
            </el-row>
            <el-row v-if='!!param.campusName'>
              <el-col :span="8" :xs="12">校区: {{ param.campusName }}</el-col>
            </el-row>
            <el-row class="sign-title-row">
              <el-col :span="8" :xs="12">状态:<span :class="{ 'color-active': param.status == '已激活' }">{{ param.status }}</span></el-col>
              <el-col :span="14" :xs="12"><span class="sign-title-warning" v-show="hasWarning">当前数据没有保存，请保存</span></el-col>
            </el-row>
          </el-row>

          <el-row class="sign-table-container">
            <el-table :key="signInTableKey" ref="signInMgTable" max-height="650" :data="pageListData" stripe style="width: 100%; " :cell-class-name="cellStyle"
              header-row-class-name="el-table-header" :row-class-name="tableRowClassName">
              <el-table-column prop="StudentName" fixed label="手机号码" width="160" header-align="center" align="center">
                <template slot-scope="scope">
                  <span class="cs-ensureA-phone">
                    <span>{{ scope.row.StudentName }}</span>
                    <span v-if="scope.row.IsEnsureACourse" class="cs-redLabel cs-ensureA-star">*</span>
                    <span v-if="scope.row.IsRefund" class="cs-redLabel">(退课)</span>
                  </span>
                </template>
              </el-table-column>

              <el-table-column v-for="(week, weekIndex) in tableData.SignInMgtWeekList" :key="weekIndex" :render-header="renderWeekHeader"
                ref="signInMgtWeekList" :label="week.WeekText + '|' + week.DateText + '|' + week.CourseActivationList.length + '|' + weekIndex" width="150"
                header-align="center">
                <el-table-column :render-header="renderGroupHeader" header-align="center" :label="week.WeekText + '|' + weekIndex + '|' + indexGroup"
                  v-for="(group, indexGroup ) in getMergeGroup(week.CourseActivationList)" :key="indexGroup">
                  <el-table-column v-for="(course, indexCourse) in group" :class-name="!course.IsNotSignIn ? '' : 'cs-signInManage-grey'"
                    :render-header="(h, obj) => renderCourseHeader(h, obj, course)" :key="indexCourse"
                    :label="course.CourseActivationId + '|' + course.ActiveTimeText + (!course.IsNotSignIn ? '' : '(不计签到)')" header-align="center"
                    :width="week.CourseActivationList.length > 0 ? 240 : 150">
                    <template slot-scope="scope">
                      <signInMangeEditCourse
                        :dataIn="{ isView: isView || course.IsNotSignIn, hasSignIn: !course.IsNotSignIn, summaryEditable: !isView, scope: scope, course: course, week: week, tableData: tableData, courseCategoryList: courseCategoryList }"
                        @save="onCourseSave" @view="onVideoView" @courseEdit="onCourseEdit" @dataChange="onDataChange"></signInMangeEditCourse>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="group.length > 1" label-class-name="merge-column-title" label="合并课程" header-align="center" align="center" width="120">
                    <template slot-scope="scope">
                      <signInMangeMergeCourse :dataIn="{ isView: isView, scope: scope, group: group, week: week, tableData: tableData }">
                      </signInMangeMergeCourse>
                    </template>
                  </el-table-column>
                </el-table-column>

                <el-table-column label="缺勤率" header-align="center" align="center" v-if="!!absenceCourseWeek[week.Week]">
                  <template slot-scope="scope">
                    <el-row class="text-center">
                      <span>{{ getAbsenceCourseWeekForStudent(week.Week, scope.row.StudentId) }}</span>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column prop="AbsentCount" label="缺课" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-row class="text-center" v-if="scope.row.StudentId < 0">
                    <span> {{ getTotalAbsentCount(scope) }} </span>
                  </el-row>
                  <el-row class="text-center" v-if="scope.row.StudentId > 0">
                    <span>{{ scope.row.AbsentCount }}</span>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="TruancyCount" label="旷课" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-row class="text-center" v-if="scope.row.StudentId < 0">
                    <span> {{ getTotalTruancyCount(scope) }} </span>
                  </el-row>
                  <el-row class="text-center" v-if="scope.row.StudentId > 0">
                    <span>{{ scope.row.TruancyCount }}</span>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="LateCount" label="缺时" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-row class="text-center" v-if="scope.row.StudentId < 0">
                    <span> {{ getTotalLateCount(scope) }} </span>
                  </el-row>
                  <el-row class="text-center" v-if="scope.row.StudentId > 0">
                    <span>{{ scope.row.LateCount }}</span>
                  </el-row>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="AttendancePercentage" label="出勤率" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-row class="text-center" v-if="scope.row.StudentId < 0">
                    <span> {{ getTotalAttendancePercentage(scope) }}% </span>
                  </el-row>
                  <el-row class="text-center" v-if="scope.row.StudentId > 0">
                    <span>{{ scope.row.AttendancePercentage ? scope.row.AttendancePercentage : 0 }}%</span>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="AttendancePercentage" label="缺勤率" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-row class="text-center" v-if="scope.row.StudentId < 0">
                    <span> {{ getTotalAbsentPercentage(scope) }}% </span>
                  </el-row>
                  <el-row class="text-center" v-if="scope.row.StudentId > 0">
                    <span>{{ scope.row.AbsentPercentage ? scope.row.AbsentPercentage : 0 }}%</span>
                  </el-row>
                </template>
              </el-table-column> -->
            </el-table>
            <el-pagination v-if="displayPagination" class="cs-pagination" background @size-change="pageSizeChange" @current-change="currentPageChange"
              :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
            </el-pagination>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="上传视频" :center="true" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="sproutVideoUploadVisible"
      :before-close="onBeforeClose" top="8vh" width="600px">
      <sproutVideoUpload :dataIn="sproutVideoUploadData" @success="onVideoUploadSuccess" @beforeUpload="onBeforeUpload" @fileUploadError="onFileUploadError">
      </sproutVideoUpload>
    </el-dialog>
    <el-dialog title="上传视频-阿里云" :center="true" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="aliyunVodUploadVisible"
      :before-close="onBeforeClose" top="8vh" width="600px">
      <aliyunVodUpload :dataIn="aliyunVodUploadData" @success="onVideoUploadSuccess" @beforeUpload="onBeforeUpload" @fileUploadError="onFileUploadError">
      </aliyunVodUpload>
    </el-dialog>
    <el-dialog v-if="sproutVideoViewVisible" title="视频" :center="true" :close-on-click-modal="false" :visible.sync="sproutVideoViewVisible" top="8vh"
      width="630px">
      <div v-html="sproutVideoPath"></div>
    </el-dialog>
    <el-dialog :title="courseActivationEditorTitle" :center="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="courseActivationEditorVisible" top="8vh" width="600px">
      <courseActivationEditor :course="editCourse" @success="onCourseActivationEditorSuccess"></courseActivationEditor>
    </el-dialog>
    <cancelCourseActivationDialog :visible.sync="showCancelCourseActivation" :loading="cancelCourseActivationLoading"
      @submit="submitCancelCourseActivation"></cancelCourseActivationDialog>

    <el-dialog class="cs-aliyunVideo-container" v-if="aliyunVideoViewVisible" :center="true" :close-on-click-modal="false"
      :visible.sync="aliyunVideoViewVisible" @close="onCloseAliyunVideo" top="8vh" width="900px">
      <aliyunVideoPlayer
        v-if="aliyunVideoInfo"
        :videoInfo="aliyunVideoInfo"
        :hideErrorMessage="hideAliyunVideoPlayerError"
        @play="onAliyunVideoPlayerPlay"
        @pause="onAliyunVideoPlayerPause"
      />
    </el-dialog>
  </div>
</template>

<style lang="scss">
#sign-in-manage-edit {
  .course-time {
    color: #207cbd;
  }

  .el-table--scrollable-x .el-table__body-wrapper {
    min-height: 200px;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .sign-remark {
    color: #b4b4b4;
    font-size: 12px;
  }

  .icon-make-sign {
    font-weight: bolder;
    font-size: 18px;
  }

  .icon-not-sign-color {
    color: red;
  }

  .text-center {
    text-align: center;
  }

  .cs-ensureA-phone {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
  }

  .cs-ensureA-star {
    font-size: 20px;
    line-height: 1;
    margin-left: 2px;
    font-weight: 700;
  }

  .clear-left-right-padding {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .select-sign-in-type-row {
    padding-left: 5px;
    padding-right: 5px;
  }

  .select-sign-in-type-row-first {
    padding-top: 10px;
  }

  .select-sign-in-type-row .min-input {
    padding: 0px !important;
    padding-left: 5px !important;
  }

  .el-input__inner {
    height: 20px !important;
    line-height: 20px;
    padding-left: 2px;
    padding-right: 2px;
  }

  .el-date-editor {
    width: 100%;

    .el-input__icon {
      line-height: 12px;
    }

    .el-range-separator {
      line-height: 12px;
      padding: 0;
      z-index: 99;
    }
  }

  .sign-content {
    margin-left: 20px;
  }

  .sign-title-row {
    padding-top: 8px;
    .sign-title-warning {
      color: red;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .sign-table-container {
    margin-top: 30px;
  }

  .color-active {
    color: #2ab893;
  }

  .icon-color {
    color: #35b02b;
  }

  .btn-save-sign-in {
    position: absolute; //z-index: 1000;
    right: 0px;
    top: 8px;
    cursor: pointer;
  }

  .header-week {
    line-height: 22px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .header-merge {
    line-height: 15px;
    padding-top: 10px;
  }

  .header-not-active {
    color: #b4b4b4;
  }

  .job-icon {
    padding: 5px;
    padding-left: 7px;
    padding-right: 7px;
    cursor: default;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .on-job-icon {
    background-color: #2ab893;
    border-color: #2ab893;
  }

  .merge-column-title {
    color: #2ab893;
  }

  .header-merge,
  .header-course {
    label {
      margin-bottom: 0;
    }

    a {
      margin-right: 5px;
    }
  }

  .cs-signInManage-grey {
    background-color: rgba(128, 128, 128, 0.8);
    color: #333;
  }

  th.cs-signInManage-grey {
    background-color: #c9c9c9;
  }

  .cs-signInManage-lastRow {
    .cs-signInManage-grey {
      background-color: transparent;

      &.el-table-cell-single {
        background-color: whitesmoke;
      }

      &.el-table-cell-double {
        background-color: #fafafa;
      }
    }
  }

  .cs-sign-table-cancelBtn {
    display: block;
    margin: 4px auto 0;
  }

  .cs-sign-table-uploadBtn {
    //margin-left: 10px;

    .cs-sign-table-uploadTime {
      display: block;
      margin-top: 3px;
    }
  }

  .cs-sign-table-emailLbl {
    color: brown;
    display: block;
  }
}

.cs-sproutVideo-container,
.cs-aliyunVideo-container {
  .el-dialog__headerbtn {
    top: 10px;
  }
}
</style>

<script>
import {
  getSignInManagementData,
  saveStudentSignIns,
  mergeWeekCourse,
  saveCourseActivationCourseMinutes,
  getTeacherCourseAttendanceInWeek,
  getTeacherCourseAttendanceInWeeks,
  saveStudentCourseAttendanceHistory,
  cancelCourseActivation,
} from "../../service/signInManage.service";
import { getCourseCategoryList } from "../../service/common.service.js";
import global_ from "@/core/global";
import signInMangeEditCourse from "./signInMangeEditCourse";
import signInMangeMergeCourse from "./signInMangeMergeCourse";
import { getSproutVideoPathByCA } from "@/service/videoAppointment.service";
import { getAliyunVodVideoInfoByCA } from "@/service/alibabaCloud.service";

export default {
  components: {
    signInMangeEditCourse,
    signInMangeMergeCourse,
    sproutVideoUpload: () => import("../sproutVideo/videoUpload"),
    aliyunVodUpload: () => import("../aliyunVod/videoUpload"),
    aliyunVideoPlayer: () => import("../aliyunVod/aliyunVideoPlayer"),
    courseActivationEditor: () => import("./courseActivationEditor"),
    cancelCourseActivationDialog: () => import("./cancelCourseActivationDialog"),
  },
  data() {
    return {
      signTypes: [
        {
          Id: 1,
          Label: "正常",
        },
        {
          Id: 2,
          Label: "缺时",
        },
        {
          Id: 3,
          Label: "缺课",
        },
        {
          Id: 4,
          Label: "旷课",
        },
      ],
      tableData: {},
      signInTableKey: "",
      param: {},
      isManager: this.USERMANAGER.isManager || this.USERMANAGER.isAdmin,
      isView: true,
      showCancelCourseActivation: false,
      cancelCourseActivationLoading: false,
      cancelCourseActivationId: 0,
      courseCategoryList: [],
      selectedWeekList: [],
      selectedCourseActivationIdList: [],
      selectedCourseList: [],
      absenceCourseWeek: {},
      isSaveAttendance: false,
      displayPagination: true,
      pageSize: 100,
      currentPage: 1,
      recordTotal: 0,
      pageListData: [],
      isUploading: false,
      sproutVideoUploadVisible: false,
      sproutVideoViewVisible: false,
      sproutVideoPath: "",
      sproutVideoUploadData: {
        courseActivationId: 0,
        weekLabel: "",
      },
      aliyunVodUploadVisible: false,
      aliyunVodUploadData: {
        courseActivationId: 0,
        weekLabel: "",
      },
      aliyunVideoViewVisible: false,
      aliyunVideoInfo: null,
      isAliyunVideoPlayerPlay: false,
      hideAliyunVideoPlayerError: true,
      editCourse: {},
      courseActivationEditorVisible: false,
      courseActivationEditorTitle: "编辑课节",
      hasWarning: false,
    };
  },
  created() {
    this.param = this.$route.query;
    this.setIsView();

    getCourseCategoryList(1).then((result) => {
      if (!!result && result.success) {
        let list = result.data;
        list.splice(
          list.findIndex((item) => item.Key == 2),
          1
        );
        this.courseCategoryList = list;
      }
    });

    this.getListData();
  },
  computed: {
    uploadBtnText(courseActivationId) {
      return function (courseActivationId) {
        let txt = "上传视频";
        for (let i = 0; i < this.tableData.SignInMgtWeekList.length; i++) {
          let item = this.tableData.SignInMgtWeekList[
            i
          ].CourseActivationList.find(
            (i) => i.CourseActivationId == courseActivationId
          );
          if (!!item && item.HasVideo) {
            txt += item.IsReady
              ? "(已上传)" +
                (item.VideoUploadTimeText
                  ? '<span class="cs-sign-table-uploadTime">' +
                    item.VideoUploadTimeText +
                    "</span>"
                  : "")
              : "(转码中)";
            break;
          }
        }
        return txt;
      };
    },
    // 前台（isFrontDesk）、教务总监、教务助理、管理员。
    canCancelCourseActivation() {
      const user = this.USERMANAGER;
      return user.isAdmin || user.isFrontDesk || user.isAcademicDirector || user.isEducationalAssistant;
    },
  },
  methods: {
    pageSizeChange(value) {
      this.pageSize = value;
      this.currentPage = 1;
      this.loadPageData();
    },
    currentPageChange(value) {
      this.currentPage = value;
      this.loadPageData();
    },
    loadPageData(scrollToCurrent) {
      this.recordTotal = this.tableData.SignInMgtStudentList.length;
      if (this.recordTotal > 50) {
        this.displayPagination = true;
      }
      if (this.displayPagination) {
        let list = [];
        let pageCount = parseInt(this.recordTotal / this.pageSize);
        if (this.recordTotal % this.pageSize > 0) {
          pageCount++;
        }

        let startIndex = (this.currentPage - 1) * this.pageSize;
        let endIndex = startIndex + this.pageSize;
        for (let i = startIndex; i < endIndex; i++) {
          if (i < this.recordTotal) {
            list.push(this.tableData.SignInMgtStudentList[i]);
          }
        }
        this.pageListData = list;
      } else {
        this.pageListData = this.tableData.SignInMgtStudentList;
      }
      if (scrollToCurrent) {
        let index = this.tableData.SignInMgtWeekList.findIndex(
          (i) => i.IsCurrent
        );
        if (index >= 0) {
          this.$nextTick(() => {
            let table = this.$refs.signInMgTable;
            table.$el.scrollIntoView();
            //console.log(table);
            //this.$refs.signInMgTable.$el.scrollIntoView();
            //this.$refs.signInMgtWeekList[index].$el.scrollIntoView();
          });
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.tableData.SignInMgtStudentList.length - 1) {
        return "cs-signInManage-lastRow";
      }

      return "";
    },
    saveAttendance() {
      if (this.isSaveAttendance) return;
      this.isSaveAttendance = true;

      saveStudentCourseAttendanceHistory(
        this.param.termId,
        this.param.teacherId,
        this.param.courseId,
        this.param.campusId
      ).then((result) => {
        if (!!result && result.success) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else {
          this.$message.error(result.message);
        }
        this.isSaveAttendance = false;
        this.getListData();
      });
    },
    calculateAbsence() {
      if (
        this.selectedCourseActivationIdList &&
        this.selectedCourseActivationIdList.length > 0
      ) {
        getTeacherCourseAttendanceInWeeks(
          this.param.termId,
          this.param.teacherId,
          this.param.courseId,
          this.param.campusId,
          this.selectedCourseActivationIdList
        ).then((result) => {
          this.tableData.SignInMgtStudentList.forEach((student) => {
            let attendance = result.data.filter(
              (i) => i.StudentId == student.StudentId
            )[0];
            if (attendance) {
              student.StudentName =
                attendance.StudentName +
                "(" +
                attendance.AbsentPercentage +
                "%)";
            }
          });
        });
      } else {
        this.$message({
          message: "请勾选日期",
          type: "warning",
        });
      }
    },
    loadAbsenceCourseWeek(weekNumber) {
      getTeacherCourseAttendanceInWeek(
        this.param.termId,
        this.param.teacherId,
        this.param.courseId,
        this.param.campusId,
        weekNumber
      ).then((result) => {
        if (!!result && result.success) {
          if (!this.absenceCourseWeek) {
            this.absenceCourseWeek = {};
          }

          this.$set(this.absenceCourseWeek, weekNumber, result.data);
        }
      });
    },
    getAbsenceCourseWeekForStudent(weekNumber, studentId) {
      if (studentId == 0) return "";
      if (!!this.absenceCourseWeek) {
        let list = this.absenceCourseWeek[weekNumber];
        let itemData = list.filter((i) => i.StudentId == studentId);
        if (!!itemData && itemData.length > 0) {
          return itemData[0].AbsentPercentage + "%";
        }
      }
      return "";
    },
    recalculateAbsenceCourseWeek(weekNumber) {
      let keys = Object.keys(this.absenceCourseWeek);
      keys.forEach((element) => {
        let n = parseInt(element);
        if (n >= weekNumber) {
          this.loadAbsenceCourseWeek(n);
        }
      });
    },
    renderGroupHeader(createElement, { column }) {
      const _self = this;
      var oDiv = createElement(
        "div",
        {
          class: {
            "header-merge": true,
          },
        },
        [
          this.isView
            ? "课程"
            : createElement("el-checkbox", {
                props: {
                  size: "small",
                  label: "合并",
                  name: column.label,
                },
                nativeOn: {
                  click(event) {
                    let index = column.label.split("|")[1];
                    let week = _self.tableData.SignInMgtWeekList[index];
                    let currentWeek = week.Week;
                    let isStop = false;
                    if (
                      _self.selectedWeekList.length > 1 &&
                      _self.selectedWeekList.indexOf(currentWeek) < 0
                    ) {
                      isStop = true;
                    } else if (_self.selectedWeekList.length == 1) {
                      let selectedWeek = _self.selectedWeekList[0];
                      if (
                        selectedWeek != currentWeek &&
                        selectedWeek != currentWeek + 1 &&
                        selectedWeek != currentWeek - 1
                      ) {
                        isStop = true;
                      }
                    }
                    if (isStop) {
                      _self.$message("只能选择相邻周的课程！");
                      event.preventDefault();
                    }
                  },
                },
                on: {
                  change(value, element) {
                    var index = column.label.split("|")[1];
                    var week = _self.tableData.SignInMgtWeekList[index];

                    var groupIndex = column.label.split("|")[2];
                    var group = _self.getMergeGroup(week.CourseActivationList);

                    var g = group[groupIndex];
                    let courseList = g.map((i) => {
                      return i.CourseActivationId;
                    });

                    if (!week.SelectedCourseList) {
                      week.SelectedCourseList = [];
                    }

                    courseList.forEach((el) => {
                      let n = _self.selectedCourseList.indexOf(el);
                      if (value) {
                        if (n < 0) {
                          _self.selectedCourseList.push(el);
                        }
                      } else {
                        if (n >= 0) {
                          _self.selectedCourseList.splice(n, 1);
                        }
                      }

                      let indexInWeek = week.SelectedCourseList.indexOf(el);
                      if (value) {
                        if (indexInWeek < 0) {
                          week.SelectedCourseList.push(el);
                        }
                      } else {
                        if (indexInWeek >= 0) {
                          week.SelectedCourseList.splice(indexInWeek, 1);
                        }
                      }
                    });

                    let indexWeek = _self.selectedWeekList.indexOf(week.Week);
                    if (week.SelectedCourseList.length > 0) {
                      if (indexWeek < 0) {
                        _self.selectedWeekList.push(week.Week);
                      }
                    } else {
                      if (indexWeek >= 0) {
                        _self.selectedWeekList.splice(indexWeek, 1);
                      }
                    }
                  },
                },
              }),
        ]
      );
      return oDiv;
    },
    renderCourseHeader(createElement, { column, $index }, ca) {
      const _self = this;
      let courseActivationId = column.label.split("|")[0];
      let label = column.label.split("|")[1];
      if (!ca.IsNotSignIn) {
        return createElement(
          "span",
          {
            class: {
              "header-course": true,
            },
          },
          [
            createElement("el-checkbox", {
              props: {
                size: "small",
                label: " ",
                name: column.label,
              },
              on: {
                change(value, element) {
                  let index =
                    _self.selectedCourseActivationIdList.indexOf(
                      courseActivationId
                    );
                  if (value) {
                    if (index < 0) {
                      _self.selectedCourseActivationIdList.push(
                        courseActivationId
                      );
                    }
                  } else {
                    if (index >= 0) {
                      _self.selectedCourseActivationIdList.splice(index, 1);
                    }
                  }
                },
              },
            }),
            createElement("a", [label]),
            _self.createUploadButton(
              createElement,
              courseActivationId,
              label,
              _self,
              ca
            ),
            _self.createCancelCourseButton(createElement, courseActivationId),
          ]
        );
      } else {
        return createElement(
          "span",
          {
            class: {
              "header-course": true,
            },
          },
          [
            createElement("a", [label]),
            _self.createUploadButton(
              createElement,
              courseActivationId,
              label,
              _self,
              ca
            ),
            _self.createCancelCourseButton(createElement, courseActivationId),
          ]
        );
      }
    },
    renderWeekHeader(createElement, { column }) {
      if (column.label.split("|")[2] == 0) {
        return createElement(
          "div",
          {
            class: {
              "header-week": true,
              "header-not-active": true,
            },
          },
          [
            createElement("a", [column.label.split("|")[0]]),
            createElement("br"),
            createElement("a", [column.label.split("|")[1]]),
          ]
        );
      }

      let _self = this;
      let oDiv = createElement(
        "div",
        {
          class: {
            "header-week": true,
            "header-not-active": column.label.split("|")[2] == 0,
          },
        },
        [
          createElement("a", [column.label.split("|")[0]]),
          createElement("br"),
          createElement("a", [column.label.split("|")[1]]),
          //this.isView ? "" : createElement("br"),
          createElement("br"),
          this.isView
            ? ""
            : createElement(
                "el-button",
                {
                  props: {
                    size: "mini",
                    type: "success",
                    class: "job-icon on-job-icon",
                  },
                  on: {
                    click(e) {
                      let weekIndex = column.label.split("|")[3];
                      let week = _self.tableData.SignInMgtWeekList[weekIndex];
                      // let selectCourseListStr = week.SelectCourseListStr;
                      // _self.mergeWeekCourse(selectCourseListStr, true);
                      _self.mergeWeekCourse(
                        week,
                        _self.selectedCourseList,
                        true
                      );
                    },
                  },
                },
                "合并"
              ),
          this.isView
            ? ""
            : createElement(
                "el-button",
                {
                  props: {
                    size: "mini",
                    type: "cancel",
                    class: "job-icon on-job-icon",
                  },
                  on: {
                    click(e) {
                      let weekIndex = column.label.split("|")[3];
                      let week = _self.tableData.SignInMgtWeekList[weekIndex];
                      // let selectCourseListStr = week.SelectCourseListStr;
                      // _self.mergeWeekCourse(selectCourseListStr, false);
                      _self.mergeWeekCourse(
                        week,
                        _self.selectedCourseList,
                        false
                      );
                    },
                  },
                },
                "拆分"
              ),
          createElement(
            "el-button",
            {
              props: {
                size: "mini",
                type: "primary",
                class: "job-icon on-job-icon",
              },
              on: {
                click(e) {
                  let weekIndex = column.label.split("|")[3];
                  let week = _self.tableData.SignInMgtWeekList[weekIndex];
                  _self.loadAbsenceCourseWeek(week.Week);
                },
              },
            },
            "缺勤率"
          ),
        ]
      );
      return oDiv;
    },
    createCancelCourseButton(createElement, courseActivationId) {
      if (!this.canCancelCourseActivation) {
        return "";
      }
      const _self = this;
      return createElement("el-button", {
        class: { "cs-sign-table-cancelBtn": true },
        props: {
          size: "mini",
          type: "danger",
        },
        on: {
          click() {
            const id = parseInt(courseActivationId, 10);
            if (!id) {
              return;
            }
            _self.cancelCourseActivationId = id;
            _self.showCancelCourseActivation = true;
          },
        },
      }, "撤销课节");
    },
    submitCancelCourseActivation(reason) {
      if (!this.cancelCourseActivationId || this.cancelCourseActivationLoading) {
        return;
      }
      this.cancelCourseActivationLoading = true;
      cancelCourseActivation(this.cancelCourseActivationId, reason).then((result) => {
        this.cancelCourseActivationLoading = false;
        if (!!result && result.success) {
          this.showCancelCourseActivation = false;
          const warning = result.data && result.data.Message;
          this.$message({
            message: warning || "课节已撤销",
            type: warning ? "warning" : "success",
          });
          this.getListData();
        } else {
          this.$message.error((result && result.message) || "撤销课节失败");
        }
      }).catch(() => {
        this.cancelCourseActivationLoading = false;
        this.$message.error("撤销课节失败");
      });
    },
    createUploadButton(createElement, courseActivationId, label, _self, ca) {
      let isSproutVideo = _self.tableData.IsSproutVideo;
      if (!isSproutVideo) {
        return "";
      }

      if (ca.CourseActivationType === 1) {
        return createElement("span", {
          class: { "cs-sign-table-emailLbl": true },
          props: {},
          domProps: {
            innerHTML: "Email",
          },
        });
      }

      let btnTxt = "上传视频";
      if (!!ca && ca.HasVideo) {
        btnTxt += ca.IsReady
          ? "(已上传)" +
            (ca.VideoUploadTimeText
              ? '<span class="cs-sign-table-uploadTime">' +
                ca.VideoUploadTimeText +
                "</span>"
              : "")
          : "(转码中)";
      }

      return createElement("el-button", {
        class: { "cs-sign-table-uploadBtn": true },
        props: {
          size: "mini",
          type: "primary",
        },
        domProps: {
          innerHTML: btnTxt, //_self.uploadBtnText(parseInt(courseActivationId)) //'上传视频'
        },
        on: {
          async click(element) {
            let id = parseInt(courseActivationId);
            await _self.onVideoUploadClick(id, label, ca);
          },
        },
      });
    },
    formatCourseMinutes(course) {
      let intValue = parseInt(course.CourseMinutes);

      if (isNaN(intValue) || intValue < 0) {
        intValue = 0;
      }

      course.CourseMinutes = intValue;
    },

    getMergeColumn(scope, group) {
      let returnCourse = {
        SignInType: 0,
        Comment: "",
      };
      let types = [];

      group.forEach((course) => {
        let studentCourse = this.getStudentSign(scope, course);
        types.push(studentCourse);
      });

      let type1 = types.find((r) => r.SignInType == 1);
      if (type1) {
        //存在正常签到
        returnCourse = {
          SignInType: 1,
          Comment: type1.Comment,
        };

        return returnCourse;
      }

      let type2 = types.find((r) => r.SignInType == 2);
      if (type2) {
        //存在迟到签到
        returnCourse = {
          SignInType: 2,
          LateMinutes: type2.LateMinutes,
          Comment: type2.Comment,
        };

        return returnCourse;
      }

      let type4 = types.find((r) => r.SignInType == 4);
      if (type4) {
        //存在旷课签到
        returnCourse = {
          SignInType: 4,
          Comment: type4.Comment,
        };

        return returnCourse;
      }

      let type3 = types.find((r) => r.SignInType == 3);
      if (type3) {
        //存在缺课签到
        returnCourse = {
          SignInType: 3,
          Comment: type3.Comment,
        };

        return returnCourse;
      }

      return returnCourse;
    },
    groupBy(xs, f) {
      return xs.reduce(
        (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
        {}
      );
    },
    getMergeGroup(courseActivationList) {
      let newResult = [];
      let result = this.groupBy(courseActivationList, (c) => c.MergeGroup);
      for (let i = 0; i < Object.keys(result).length; i++) {
        let r = result[Object.keys(result)[i]];
        if (r && r.length > 0 && r[0].MergeGroup == 0) {
          r.forEach((g) => {
            newResult.push([g]);
          });
        }
        if (r && r.length > 0 && r[0].MergeGroup > 0) {
          newResult.push(r);
        }
      }

      return newResult;
    },
    mergeWeekCourse(week, selectCourseList, isMerge) {
      if (!week.SelectedCourseList || week.SelectedCourseList.length == 0) {
        this.$message({
          type: "warning",
          message: "当前周并未选择任何课程",
        });
        return;
      }
      if (isMerge) {
        if (!selectCourseList || selectCourseList.length < 2) {
          this.$message({
            type: "warning",
            message: "至少选择两节课",
          });
          return;
        }
      } else {
        if (!selectCourseList || selectCourseList.length < 1) {
          this.$message({
            type: "warning",
            message: "需要选择一节合并课程",
            //message: "至少选择一节课"
          });
          return;
        }
      }

      mergeWeekCourse(selectCourseList, isMerge).then((result) => {
        if (!!result && result.success) {
          if (isMerge) {
            this.$message("合并成功！");
          } else {
            this.$message("拆分成功！");
          }

          this.tableData = [];
          this.getListData();
          this.recalculateAbsenceCourseWeek(week.Week);
        } else {
          if (!!result.Message) {
            this.$message.error(result.Message);
          } else if (!!result.message) {
            this.$message.error(result.message);
          }
        }
      });
    },
    getStudentSign(scope, courseActivation) {
      var row = scope.row.SignInMgtStudentSignInList.find(
        (r) => r.CourseActivationId == courseActivation.CourseActivationId
      );

      if (!row) {
        let signIntype = 4; // 大于报名日期是旷课4
        if (courseActivation.IsActive) {
          signIntype = 0;
        } else {
          let scourseTime = new Date(scope.row.StudentCourseStartTime);
          let activeTime = new Date(courseActivation.ActiveTime);

          if (activeTime < scourseTime) {
            //小于报名日期是缺课3
            signIntype = 3;
            //debugger;
          } else {
            // if (!!scope.row.HasRefund && !!scope.row.RefundTime){
            //   let refundTime = new Date(scope.row.RefundTime);
            //   if (activeTime > refundTime) {
            //     signIntype = 5;
            //   }
            // }
            if (this.checkIsRefund(activeTime, scope.row)) {
              signIntype = 5;
            }
          }
        }

        var addRow = {
          CourseActivationId: courseActivation.CourseActivationId,
          IsEditing: false,
          SignInType: signIntype,
          IsChanged: false,
          LateMinutes: 0,
          Comment: "",
          IsOffline: false,
          IsVideoFree: false,
        };
        scope.row.SignInMgtStudentSignInList.push(addRow);

        return addRow;
      }
      return row;
    },
    checkIsRefund(activeTime, row) {
      let isRefund = false;
      if (row.HasRefund) {
        let count = row.SignInCourseList.length;
        if (row.SignInCourseList[count - 1].IsRefund) {
          let refundTime = new Date(row.SignInCourseList[count - 1].RefundTime);
          if (activeTime > refundTime) {
            isRefund = true;
          }
        }
        if (count > 1) {
          let lastRefundTime = null;

          for (let i = 0; i < count; i++) {
            let item = row.SignInCourseList[i];
            let completedTime = new Date(item.CompletedTime);
            if (
              !!lastRefundTime &&
              activeTime > lastRefundTime &&
              activeTime < completedTime
            ) {
              isRefund = true;
              break;
            }

            if (!!item.RefundTime) {
              lastRefundTime = new Date(item.RefundTime);
            }
          }
        }
      }
      return isRefund;
    },
    getSignInTableKey(data) {
      const weeks = (data && data.SignInMgtWeekList) || [];
      return weeks
        .map((week) => {
          const ids = (week.CourseActivationList || [])
            .map((course) => course.CourseActivationId + ":" + course.MergeGroup)
            .join(",");
          return week.Week + "[" + ids + "]";
        })
        .join("|");
    },
    getListData() {
      this.loading = true;
      this.selectedWeekList = [];
      this.selectedCourseActivationIdList = [];
      this.selectedCourseList = [];
      getSignInManagementData(
        this.param.termId,
        this.param.teacherId,
        this.param.courseId,
        this.param.campusId
      ).then((result) => {
        if (!!result && result.success) {
          let resultData = result.data;
          if (resultData && resultData.SignInMgtStudentList) {
            resultData.SignInMgtStudentList.push({
              StudentId: -1,
              StudentName: "参课人数",
              SignInMgtStudentSignInList: [],
            });
          }

          this.tableData = resultData;
          this.signInTableKey = this.getSignInTableKey(resultData);
          this.loadPageData(true);
        }
        this.loading = false;
      });
    },
    back() {
      let path, query;
      switch (this.param.back) {
        case "signInManage":
          path = "/admin/signInManage";
          query = {
            termId: this.param.termId,
            usage: this.param.usage,
          };
          if (this.param.usage === "vocationalTraining") {
            query["courseCategory"] = this.param.courseCategory;
          } else {
            query["groupNumber"] = this.param.groupNumber;
          }
          break;
        case "courseOperator":
          path = "/teacher/activateCourse";
          query = {
            groupNumber: this.param.groupNumber,
            usage: this.param.usage,
          };
          break;
        case "signInQueryList4":
          path = "/admin/signInQuery";
          break;
      }

      if (!!path) {
        this.$router.push({
          path,
          query,
        });
      }

      //  this.$router.back(-1);
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    // getStudentName(name) {
    //   if (this.isManager || name == "参课人数") {
    //     return name;
    //   }

    //   if (name && name.length > 0) {
    //     let firstName = name.substring(0, 1);
    //     let lastName = "";
    //     if (name.length > 4) {
    //       lastName = name.substring(name.length - 4, name.length);
    //     }
    //     //显示手机的后5位，需求来自Frank微信
    //     if (name.length > 5) {
    //       firstName = name.substring(name.length - 5, name.length - 4);
    //     }
    //     return firstName + "-" + lastName;
    //   }
    // },
    setIsView() {
      this.isView = this.USERMANAGER.isTeacher;
    },
    getTotalCount(scope, course) {
      return course.StudentCount;
    },
    getAttendanceCount(scope, course) {
      //debugger;
      let count = 0;
      let id = course.CourseActivationId;
      this.tableData.SignInMgtStudentList.forEach((element) => {
        let signIn = element.SignInMgtStudentSignInList.filter(
          (i) => i.CourseActivationId == id
        );

        if (signIn && signIn.length > 0) {
          if (signIn[0].SignInType == 1 || signIn[0].SignInType == 2) {
            count++;
          }
        }
      });
      return count;
    },
    getMergeTotalCount(scope, group) {
      let types = [];
      let count = 0;

      let studentList = this.tableData.SignInMgtStudentList;

      group.forEach((course) => {
        let id = course.CourseActivationId;

        studentList.forEach((s) => {
          if (s.StudentId <= 0) {
            return;
          }
          if (
            s.SignInMgtStudentSignInList.findIndex(
              (s) =>
                s.CourseActivationId == id &&
                (s.SignInType == 1 || s.SignInType == 2 || s.SignInType == 4)
            ) > -1
          ) {
            if (types.findIndex((t) => t.StudentId == s.StudentId) < 0) {
              types.push({
                StudentId: s.StudentId,
              });
              count++;
            }
          }
        });
      });

      return count;
    },
    getMergeAttendanceCount(scope, group) {
      let types = [];
      let count = 0;

      let studentList = this.tableData.SignInMgtStudentList;

      group.forEach((course) => {
        let id = course.CourseActivationId;

        studentList.forEach((s) => {
          if (s.StudentId <= 0) {
            return;
          }
          if (
            s.SignInMgtStudentSignInList.findIndex(
              (s) =>
                s.CourseActivationId == id &&
                (s.SignInType == 1 || s.SignInType == 2)
            ) > -1
          ) {
            if (types.findIndex((t) => t.StudentId == s.StudentId) < 0) {
              types.push({
                StudentId: s.StudentId,
              });
              count++;
            }
          }
        });
      });

      return count;
    },
    getMergeTotalMinitues(scope, group) {
      let total = 0;
      let minitues = 0;

      if (group && group.length > 0) {
        group.forEach((g) => {
          total += parseInt(g.CourseMinutes);
        });
        minitues = total / group.length;
      }

      return minitues;
    },
    getTotalAbsentCount(scope) {
      let count = 0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.AbsentCount) {
            count += r.AbsentCount;
          }
        });
      }
      return count;
    },
    getTotalTruancyCount(scope) {
      let count = 0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.TruancyCount) {
            count += r.TruancyCount;
          }
        });
      }
      return count;
    },
    getTotalLateCount(scope) {
      let count = 0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.LateCount) {
            count += r.LateCount;
          }
        });
      }
      return count;
    },
    getTotalAttendancePercentage(scope) {
      let attendanceTotal = 0.0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.AttendancePercentage) {
            attendanceTotal += r.AttendancePercentage * 1;
          }
        });
      }
      let count = studentList.length - 1;
      let rePercent = 0;
      if (count > 0) {
        rePercent = attendanceTotal / count;
      }
      return rePercent.toFixed(1);
    },
    getTotalAbsentPercentage(scope) {
      let attendanceTotal = 0.0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.AbsentPercentage) {
            attendanceTotal += r.AbsentPercentage * 1;
          }
        });
      }
      let count = studentList.length - 1;
      let rePercent = 0;
      if (count > 0) {
        rePercent = attendanceTotal / count;
      }
      return rePercent.toFixed(1);
    },
    formatLateMinutes(row) {
      let intValue = parseInt(row.LateMinutes);

      if (isNaN(intValue) || intValue < 0) {
        intValue = 0;
      }

      row.LateMinutes = intValue;
    },
    onCourseSave(weekNumber) {
      this.recalculateAbsenceCourseWeek(weekNumber);
      let index = this.tableData.SignInMgtStudentList.findIndex(
        (i) => i.SignInMgtStudentSignInList.findIndex((j) => !!j.IsChanged) >= 0
      );
      if (index < 0) {
        this.hasWarning = false;
      }
    },
    onDataChange() {
      this.hasWarning = true;
    },
    async onVideoUploadClick(courseActivationId, label, ca) {
      let videoPlatform = this.tableData.DefaultVideoPlatform;
      //if (!ca.HasVideo) ca.VideoPlatform = this.tableData.DefaultVideoPlatform;
      switch (videoPlatform) {
        case this.GLOBAL.enumVideoPlatform.SproutVideo:
          this.sproutVideoUploadData = {
            courseActivationId: courseActivationId,
            weekLabel: label,
          };
          this.sproutVideoUploadVisible = true;
          break;
        case this.GLOBAL.enumVideoPlatform.AliyunVod:
          this.aliyunVodUploadData = {
            courseActivationId: courseActivationId,
            weekLabel: label,
          };
          this.aliyunVodUploadVisible = true;
          break;
      }
    },
    onVideoUploadSuccess(fileName, courseActivationId) {
      this.isUploading = false;
      for (let i = 0; i < this.tableData.SignInMgtWeekList.length; i++) {
        let item = this.tableData.SignInMgtWeekList[
          i
        ].CourseActivationList.find(
          (i) => i.CourseActivationId == courseActivationId
        );
        if (!!item) {
          item.HasVideo = true;
          item.IsReady =
            item.VideoPlatform !== this.GLOBAL.enumVideoPlatform.AliyunVod;
          break;
        }
      }
    },
    onFileUploadError() {
      this.isUploading = false;
    },
    onBeforeUpload() {
      this.isUploading = true;
    },
    onBeforeClose(done) {
      if (!this.isUploading) {
        done();
      }
    },
    onVideoView(course) {
      // console.log("onVideoView: ", course);

      if (!course.IsReady) {
        this.$message.warning("请等待视频完成转码");
        return;
      }

      let courseActivationId = course.CourseActivationId;
      switch (course.VideoPlatform) {
        case this.GLOBAL.enumVideoPlatform.SproutVideo:
          getSproutVideoPathByCA(courseActivationId).then((result) => {
            if (result && result.success) {
              if (course.CourseActivationType === 0) {
                this.sproutVideoPath = result.data;
                this.sproutVideoViewVisible = true;
              } else {
                if (!result.data) {
                  this.$message.warning("请等待视频完成转码");
                  return;
                }
                window.open(result.data, "_blank");
              }
            }
          });
          break;
        case this.GLOBAL.enumVideoPlatform.AliyunVod:
          getAliyunVodVideoInfoByCA(courseActivationId).then((result) => {
            if (result && result.success) {
              this.aliyunVideoInfo = result.data;
              this.aliyunVideoViewVisible = true;
            }
          });
          break;
      }
    },
    onCourseEdit(course) {
      this.editCourse = course;
      this.courseActivationEditorTitle = `编辑课节 ${course.ActiveTimeText}`;
      this.courseActivationEditorVisible = true;
    },
    onCourseActivationEditorSuccess(data) {
      this.courseActivationEditorVisible = false;
      this.editCourse.ActualStartTimeText = data.actualStartTimeText;
      this.editCourse.ActualEndTimeText = data.actualEndTimeText;
      this.editCourse.CourseMinutes = data.courseMinutes;
      this.editCourse.BreakStartTimeText = data.breakStartTimeText;
      this.editCourse.BreakEndTimeText = data.breakEndTimeText;
      this.editCourse.BreakMinutes = data.breakMinutes;
      this.editCourse.Content = data.content;
      this.editCourse.IsNotSignIn = data.isNotSignIn;
      this.editCourse.IsFreeVideo = data.isFreeVideo;
      this.editCourse.CourseCategory = data.courseCategory;
      this.editCourse.CourseCategoryText = this.getCourseCategoryText(this.editCourse.CourseCategory);
      this.editCourse.TimestampStatus = data.timestampStatus;
      this.editCourse.CameraStatus = data.cameraStatus;
      this.editCourse.SpeedupElementStatus = data.speedupElementStatus;
    },

    onCloseAliyunVideo() {
      this.aliyunVideoViewVisible = false;
      this.isAliyunVideoPlayerPlay = false;
    },
    onAliyunVideoPlayerPlay(e) {
      if (
        this.activeTab === "2" &&
        this.currentEventData &&
        this.currentEventData.row &&
        this.currentEventData.row.IsAppointment &&
        this.pauseTime
      ) {
        let currentTime = new Date();
        let validTime = new Date(Date.parse(this.pauseTime));
        let validMinutes = 5;
        validTime.setMinutes(validTime.getMinutes() + validMinutes);
        if (currentTime > validTime) {
          this.pauseTime = null;
          this.clearTimer();
          this.$refs.appointmentList.customEventHandler(this.currentEventData);
          return;
        }
      }
      this.isAliyunVideoPlayerPlay = true;
      this.pauseTime = null;
    },
    onAliyunVideoPlayerPause(e) {
      this.isAliyunVideoPlayerPlay = false;
      this.pauseTime = new Date();
    },
    getCourseCategoryText(categoryId) {
      let result = this.courseCategoryList.find(
        (i) => i.Key == categoryId
      );
      if (!!result) {
        return result.Value;
      }
      return "";
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/signInMangeEdit.vue